import { Badge } from '@chakra-ui/react'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import type { FlexGroupType } from 'BrokerTsLib/src/enums'
import { useGetFlexGroupType } from 'BrokerTsLib/src/hooks/useFlexGroup'

export const FlexGroupTypeBadge = ({ type: typeId }: { type?: FlexGroupType }) => {
  const type = useGetFlexGroupType(typeId)

  return <CustomTooltip label={type?.description} boxProps={{ justifySelf: 'left' }} hasArrow>
    <Badge colorScheme="primary" variant="solid">{type?.name}</Badge>
  </CustomTooltip>
}